export default "__VITE_ASSET__1d8b0e3b__"